import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, WalletIcon, ArrowRightIcon, CheckCircleIcon, TrendingUpIcon, UsersIcon, UserIcon, MailIcon, PhoneIcon, MapPinIcon, HelpCircleIcon, HeartPulseIcon, BriefcaseIcon, GraduationCapIcon, PiggyBankIcon, CarIcon, HomeIcon, SmartphoneIcon, PlaneIcon, CheckIcon, ChevronDownIcon, ArrowUpIcon } from 'lucide-react';
export function ComingSoon() {
  const [joined, setJoined] = useState(false);
  const [openPlanIdx, setOpenPlanIdx] = useState<number | null>(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    usesOtherApp: '',
    interests: [] as string[]
  });
  const handleInterestToggle = (interest: string) => {
    setFormData(prev => ({
      ...prev,
      interests: prev.interests.includes(interest) ? prev.interests.filter(i => i !== interest) : [...prev.interests, interest]
    }));
  };
  const handleJoin = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.name && formData.email) {
      setJoined(true);
      console.log('Waitlist Submission:', formData);
    }
  };
  const products = [{
    name: 'Wellness Plan',
    desc: 'Comprehensive health coverage for you and your family.',
    icon: HeartPulseIcon,
    theme: {
      hoverBg: 'hover:bg-cyan-50',
      hoverBorder: 'hover:border-cyan-200',
      iconBg: 'bg-cyan-100',
      iconBgHover: 'group-hover:bg-cyan-200',
      iconColor: 'text-cyan-600',
      textHover: 'group-hover:text-cyan-700'
    }
  }, {
    name: 'Income Shield',
    desc: 'Protect your earning power against unexpected life events.',
    icon: BriefcaseIcon,
    theme: {
      hoverBg: 'hover:bg-blue-50',
      hoverBorder: 'hover:border-blue-200',
      iconBg: 'bg-blue-100',
      iconBgHover: 'group-hover:bg-blue-200',
      iconColor: 'text-blue-600',
      textHover: 'group-hover:text-blue-700'
    }
  }, {
    name: 'Future Scholar Fund',
    desc: "Secure your children's education with guaranteed payouts.",
    icon: GraduationCapIcon,
    theme: {
      hoverBg: 'hover:bg-emerald-50',
      hoverBorder: 'hover:border-emerald-200',
      iconBg: 'bg-emerald-100',
      iconBgHover: 'group-hover:bg-emerald-200',
      iconColor: 'text-emerald-600',
      textHover: 'group-hover:text-emerald-700'
    }
  }, {
    name: 'Freedom Fund',
    desc: 'Build your retirement nest egg with built-in life cover.',
    icon: PiggyBankIcon,
    theme: {
      hoverBg: 'hover:bg-orange-50',
      hoverBorder: 'hover:border-orange-200',
      iconBg: 'bg-orange-100',
      iconBgHover: 'group-hover:bg-orange-200',
      iconColor: 'text-orange-600',
      textHover: 'group-hover:text-orange-700'
    }
  }, {
    name: 'GoalGuard',
    desc: 'Targeted savings for specific life goals with protection.',
    icon: TrendingUpIcon,
    theme: {
      hoverBg: 'hover:bg-yellow-50',
      hoverBorder: 'hover:border-yellow-200',
      iconBg: 'bg-yellow-100',
      iconBgHover: 'group-hover:bg-yellow-200',
      iconColor: 'text-yellow-600',
      textHover: 'group-hover:text-yellow-700'
    }
  }, {
    name: 'AutoGuard',
    desc: 'Comprehensive vehicle protection with instant claims.',
    icon: CarIcon,
    theme: {
      hoverBg: 'hover:bg-indigo-50',
      hoverBorder: 'hover:border-indigo-200',
      iconBg: 'bg-indigo-100',
      iconBgHover: 'group-hover:bg-indigo-200',
      iconColor: 'text-indigo-600',
      textHover: 'group-hover:text-indigo-700'
    }
  }, {
    name: 'Legacy Plan',
    desc: "Ensure your family's financial security when you're gone.",
    icon: UsersIcon,
    theme: {
      hoverBg: 'hover:bg-purple-50',
      hoverBorder: 'hover:border-purple-200',
      iconBg: 'bg-purple-100',
      iconBgHover: 'group-hover:bg-purple-200',
      iconColor: 'text-purple-600',
      textHover: 'group-hover:text-purple-700'
    }
  }, {
    name: 'Property Shield',
    desc: 'Protect your home and valuable assets from damage.',
    icon: HomeIcon,
    theme: {
      hoverBg: 'hover:bg-rose-50',
      hoverBorder: 'hover:border-rose-200',
      iconBg: 'bg-rose-100',
      iconBgHover: 'group-hover:bg-rose-200',
      iconColor: 'text-rose-600',
      textHover: 'group-hover:text-rose-700'
    }
  }, {
    name: 'TravelGuard',
    desc: 'Comprehensive travel protection for local and international trips.',
    icon: PlaneIcon,
    theme: {
      hoverBg: 'hover:bg-slate-50',
      hoverBorder: 'hover:border-slate-200',
      iconBg: 'bg-slate-100',
      iconBgHover: 'group-hover:bg-slate-200',
      iconColor: 'text-slate-600',
      textHover: 'group-hover:text-slate-700'
    }
  }];
  const underwriters = ['Leadway Assurance', 'AXA Mansard', 'Hygeia HMO', 'Cornerstone', 'Stanbic IBTC'];
  const interestOptions = products.map(p => p.name);
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  return <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-[#0D3B3B] selection:text-[#FFD700] overflow-x-hidden" data-id="element-1343">
      {/* Hero Section - YELLOW IS THE MAIN THING */}
      <div className="bg-[#FFD700] text-[#0D3B3B] pt-6 pb-24 md:pb-32" data-id="element-1344">
        {/* Navigation */}
        <nav className="container mx-auto px-6 flex justify-between items-center relative z-20 mb-12 md:mb-20" data-id="element-1345">
          <img src="https://cdn.magicpatterns.com/uploads/urMXFPH61J79xPimgGTTYX/Group_578.png" alt="Skydd" className="h-8 w-auto" data-id="element-1346" />
          <a href="#waitlist" className="hidden md:flex items-center gap-2 text-sm font-bold text-[#0D3B3B] hover:opacity-70 transition-opacity" data-id="element-1347">
            Join Early Access <ArrowRightIcon className="w-4 h-4" data-id="element-1348" />
          </a>
        </nav>

        <main className="container mx-auto px-6 relative z-20" data-id="element-1349">
          <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20" data-id="element-1350">
            {/* Left: Text Content */}
            <motion.div initial="hidden" animate="visible" variants={fadeUp} className="flex-1 text-center lg:text-left max-w-2xl mx-auto lg:mx-0" data-id="element-1351">
              

              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[80px] font-black leading-[1.05] tracking-tight mb-6 text-[#0D3B3B]" data-id="element-1352">
                Your Goals.
                <br data-id="element-1353" />
                Guaranteed.
              </h1>

              <p className="text-lg md:text-xl text-[#0D3B3B]/80 mb-10 max-w-xl mx-auto lg:mx-0 leading-relaxed font-medium" data-id="element-1354">
                Skydd is evolving into Nigeria's first insure-fintech super-app
                — combining protection, savings, and financial tools in one
                beautiful experience.
              </p>

              <div className="flex justify-center lg:justify-start" data-id="element-1355">
                <a href="#waitlist" className="bg-[#0D3B3B] hover:bg-[#154B4B] text-[#FFD700] px-8 py-4 rounded-full text-lg font-bold transition-transform active:scale-95 shadow-xl shadow-[#0D3B3B]/20 inline-flex items-center gap-2" data-id="element-1356">
                  Join Early Access <ArrowRightIcon className="w-5 h-5" data-id="element-1357" />
                </a>
              </div>
            </motion.div>

            {/* Right: Mascot & Visuals */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            delay: 0.2,
            ease: 'easeOut'
          }} className="flex-1 relative w-full max-w-lg mx-auto lg:max-w-none flex flex-col items-center lg:items-end" data-id="element-1358">
              <div className="relative w-full max-w-[500px] aspect-square flex items-center justify-center mt-10 lg:mt-0" data-id="element-1359">
                {/* Background glow */}
                <div className="absolute inset-0 bg-white/20 rounded-full blur-3xl" data-id="element-1360" />

                {/* Main Image - Joyful Woman */}
                <motion.div initial={{
                opacity: 0,
                rotate: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                rotate: 4,
                scale: 1
              }} transition={{
                duration: 0.8,
                delay: 0.2
              }} className="absolute right-0 md:right-4 top-8 w-[65%] aspect-[4/5] rounded-[2rem] border-[6px] border-white shadow-2xl overflow-hidden z-10" data-id="element-1361">
                  <img src="https://cdn.magicpatterns.com/uploads/4fAGbTJbhKZVBuPfx8izCz/image.png" alt="Joyful woman" className="w-full h-full object-cover" data-id="element-1362" />
                </motion.div>

                {/* Secondary Image - Father & Daughter */}
                <motion.div initial={{
                opacity: 0,
                rotate: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                rotate: -6,
                scale: 1
              }} transition={{
                duration: 0.8,
                delay: 0.4
              }} className="absolute left-0 bottom-16 w-[60%] aspect-[4/3] rounded-[2rem] border-[6px] border-white shadow-2xl overflow-hidden z-20" data-id="element-1363">
                  <img src="https://cdn.magicpatterns.com/uploads/cTnS3YWsG65c2yRFtERvzS/0-13-696x686.jpg" alt="Father and daughter" className="w-full h-full object-cover" data-id="element-1364" />
                </motion.div>

                {/* Mascot - Floating */}
                <motion.img animate={{
                y: [0, -12, 0]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut'
              }} src="https://cdn.magicpatterns.com/uploads/vJQZF1GRsZggegtRVotgXV/DD_waving_hero_1.png" alt="DD Waving Hero" className="absolute -top-12 left-4 md:left-8 w-[180px] md:w-[220px] z-30 drop-shadow-2xl" data-id="element-1365" />

                {/* Floating Badge */}
                <motion.div animate={{
                y: [0, -8, 0]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 1
              }} className="absolute bottom-8 -right-4 md:-right-8 bg-[#0D3B3B] p-4 rounded-2xl shadow-2xl z-30 border border-white/20" data-id="element-1366">
                  <div className="flex items-center gap-3" data-id="element-1367">
                    <div className="w-12 h-12 bg-[#FFD700] rounded-full flex items-center justify-center shrink-0" data-id="element-1368">
                      <WalletIcon className="w-6 h-6 text-[#0D3B3B]" data-id="element-1369" />
                    </div>
                    <div data-id="element-1370">
                      <p className="text-[10px] text-white/70 font-bold uppercase tracking-wider mb-0.5" data-id="element-1371">
                        Saved
                      </p>
                      <p className="text-lg font-black text-white" data-id="element-1372">
                        ₦4,200,000
                      </p>
                    </div>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </main>
      </div>

      {/* The Skydd Smile - Clean Standalone Graphic */}
      {/* Removed from background to prevent overlapping issues. Now acts as a beautiful transition. */}
      <div className="bg-white w-full flex justify-center items-center py-12 md:py-20 px-6" data-id="element-1373">
        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} src="https://cdn.magicpatterns.com/uploads/jo5L6ov82Y7HjZNEqWbwgc/Vector.svg" alt="Skydd Smile" className="w-full max-w-4xl h-auto" data-id="element-1374" />
      </div>

      {/* Platform Overview Section */}
      <section className="pb-24 md:pb-32 bg-white relative z-20" data-id="element-1375">
        <div className="container mx-auto px-6" data-id="element-1376">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeUp} className="text-center mb-20" data-id="element-1377">
            <h2 className="text-3xl md:text-5xl font-black mb-6 text-[#0D3B3B] tracking-tight" data-id="element-1378">
              The New Skydd
            </h2>
            <div className="w-16 h-1.5 bg-[#FFD700] rounded-full mx-auto mb-6" data-id="element-1379" />
            <p className="text-gray-600 max-w-2xl mx-auto text-lg md:text-xl font-medium leading-relaxed" data-id="element-1380">
              We are evolving beyond traditional insurance. Skydd is now a
              comprehensive platform designed to protect your wealth, grow your
              savings, and manage your financial life seamlessly.
            </p>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={staggerContainer} className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-1381">
            {[{
            title: 'Protection',
            desc: 'Instant, paperless coverage for your health, life, vehicles, and valuable assets.',
            mascot: 'https://cdn.magicpatterns.com/uploads/twohoUfqTs4sUfnNQ4Jbt5/DD_with_umbrella_1.png',
            color: 'text-[#2BA89D]',
            bg: 'bg-[#2BA89D]/10',
            border: 'border-[#2BA89D]/20'
          }, {
            title: 'Savings',
            desc: 'Goal-based savings plans that come with built-in life cover to guarantee your targets.',
            mascot: 'https://cdn.magicpatterns.com/uploads/ddGEqtHHBLaRgK5q4UKEDw/DD_winking_1.png',
            color: 'text-amber-600',
            bg: 'bg-[#FFD700]/20',
            border: 'border-[#FFD700]/50'
          }, {
            title: 'Financial Tools',
            desc: 'Digital wallets, seamless transfers, bill payments, and smart budgeting insights.',
            mascot: 'https://cdn.magicpatterns.com/uploads/fCtTe1ZG3m1ZsjnpHbbpZx/DD_standing_front_1.png',
            color: 'text-indigo-700',
            bg: 'bg-indigo-100',
            border: 'border-indigo-200'
          }].map((item, idx) => <motion.div key={idx} variants={fadeUp} className={`bg-white p-10 rounded-3xl border ${item.border} shadow-sm hover:shadow-2xl transition-all duration-300 text-center group`} data-id="element-1382">
                <div className={`w-32 h-32 mx-auto rounded-full flex items-center justify-center mb-8 ${item.bg} relative`} data-id="element-1383">
                  <img src={item.mascot} alt={item.title} className="w-28 h-28 object-contain absolute bottom-2 group-hover:scale-110 group-hover:-translate-y-2 transition-all duration-300 drop-shadow-lg" data-id="element-1384" />
                </div>
                <h3 className={`text-2xl font-black mb-4 ${item.color}`} data-id="element-1385">
                  {item.title}
                </h3>
                <p className="text-gray-600 font-medium leading-relaxed" data-id="element-1386">
                  {item.desc}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* Product Highlights Section */}
      <section className="py-24 md:py-32 bg-white relative overflow-hidden" data-id="element-1387">
        <div className="container mx-auto px-6 relative z-10" data-id="element-1388">
          <div className="flex flex-col lg:flex-row gap-16 lg:gap-20 items-start" data-id="element-1389">
            {/* Left Side: Header & Floating Image */}
            <div className="w-full lg:w-5/12 lg:sticky lg:top-32" data-id="element-1390">
              <motion.div initial="hidden" whileInView="visible" viewport={{
              once: true,
              margin: '-100px'
            }} variants={fadeUp} data-id="element-1391">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0D3B3B]/5 border border-[#0D3B3B]/10 text-[#0D3B3B] text-xs font-bold tracking-widest uppercase mb-6" data-id="element-1392">
                  <span className="w-2 h-2 rounded-full bg-[#2BA89D] animate-pulse" data-id="element-1393" />
                  Tailored For You
                </div>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 text-[#0D3B3B] tracking-tight leading-tight" data-id="element-1394">
                  Comprehensive <br data-id="element-1395" />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0D3B3B] to-[#2BA89D]" data-id="element-1396">
                    Life Plans
                  </span>
                </h2>
                <p className="text-gray-500 text-lg md:text-xl font-medium leading-relaxed mb-12" data-id="element-1397">
                  Tailored solutions for every stage of your life and financial
                  journey. Simple, transparent, and built for your peace of
                  mind.
                </p>

                {/* Floating Image - Not in a card */}
                <div className="relative w-full max-w-[400px] mx-auto lg:mx-0 hidden md:block" data-id="element-1398">
                  <img src="https://cdn.magicpatterns.com/uploads/d4vputbkR9T1UAqnrHf1nY/image.png" alt="Happy woman celebrating" className="w-full h-auto object-contain relative z-10" data-id="element-1399" />
                </div>
              </motion.div>
            </div>

            {/* Right Side: Plans Accordion */}
            <div className="w-full lg:w-7/12" data-id="element-1400">
              <motion.div initial="hidden" whileInView="visible" viewport={{
              once: true,
              margin: '-100px'
            }} variants={staggerContainer} className="flex flex-col gap-4" data-id="element-1401">
                {products.map((product, idx) => {
                const isOpen = openPlanIdx === idx;
                return <motion.div key={idx} variants={fadeUp} className="border-b border-gray-100 last:border-0 pb-4 pt-2" data-id="element-1402">
                      <button onClick={() => setOpenPlanIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between text-left group py-2" data-id="element-1403">
                        <div className="flex items-center gap-4" data-id="element-1404">
                          <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 transition-transform duration-300 ${isOpen ? 'scale-110' : 'group-hover:scale-105'} ${product.theme.iconBg}`} data-id="element-1405">
                            <product.icon className={`w-6 h-6 ${product.theme.iconColor}`} data-id="element-1406" />
                          </div>
                          <h3 className={`font-black text-xl tracking-tight transition-colors duration-300 ${isOpen ? 'text-[#2BA89D]' : 'text-[#0D3B3B] group-hover:text-[#2BA89D]'}`} data-id="element-1407">
                            {product.name}
                          </h3>
                        </div>
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-[#2BA89D] text-white rotate-180' : 'bg-gray-100 text-gray-400 group-hover:bg-gray-200'}`} data-id="element-1408">
                          <ChevronDownIcon className="w-5 h-5" data-id="element-1409" />
                        </div>
                      </button>

                      <AnimatePresence initial={false} data-id="element-1410">
                        {isOpen && <motion.div initial={{
                      height: 0,
                      opacity: 0
                    }} animate={{
                      height: 'auto',
                      opacity: 1
                    }} exit={{
                      height: 0,
                      opacity: 0
                    }} transition={{
                      duration: 0.3,
                      ease: 'easeInOut'
                    }} className="overflow-hidden" data-id="element-1411">
                            <div className="pl-16 pr-12 pb-4 pt-2" data-id="element-1412">
                              <p className="text-gray-500 font-medium leading-relaxed text-base mb-4" data-id="element-1413">
                                {product.desc}
                              </p>
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </motion.div>;
              })}
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Waitlist Form Section */}
      <section id="waitlist" className="pt-24 md:pt-32 pb-16 md:pb-20 relative overflow-hidden bg-[#0D3B3B]" data-id="element-1414">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-1415">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-br from-[#2BA89D]/20 to-transparent blur-[100px]" data-id="element-1416" />
          <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-gradient-to-tr from-[#FFD700]/10 to-transparent blur-[100px]" data-id="element-1417" />
        </div>

        <div className="container mx-auto px-6 relative z-10" data-id="element-1418">
          {/* Section Header */}
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-1419">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#FFD700]/10 border border-[#FFD700]/20 text-[#FFD700] text-xs font-bold tracking-widest uppercase mb-6" data-id="element-1420">
              <CheckCircleIcon className="w-4 h-4" data-id="element-1421" /> Early Access
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 text-white tracking-tight leading-tight" data-id="element-1422">
              Secure Your Spot <br data-id="element-1423" />
              <span className="text-[#FFD700]" data-id="element-1424">On The Waitlist</span>
            </h2>
            <p className="text-white/80 text-lg md:text-xl font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-1425">
              Be among the first to experience the new Skydd. Join thousands of
              others waiting for the future of insure-fintech.
            </p>
          </div>

          {/* Wide Form Container */}
          <div className="max-w-4xl mx-auto bg-[#FFD700] rounded-[2rem] md:rounded-[3rem] overflow-hidden shadow-2xl shadow-[#FFD700]/20" data-id="element-1426">
            <div className="p-8 md:p-12 lg:p-16 text-[#0D3B3B]" data-id="element-1427">
              <AnimatePresence mode="wait" data-id="element-1428">
                {joined ? <motion.div key="success" initial={{
                opacity: 0,
                scale: 0.95
              }} animate={{
                opacity: 1,
                scale: 1
              }} className="flex flex-col items-center justify-center text-center py-12" data-id="element-1429">
                    <div className="w-24 h-24 bg-white/50 rounded-full flex items-center justify-center mb-8" data-id="element-1430">
                      <CheckCircleIcon className="w-12 h-12 text-[#0D3B3B]" data-id="element-1431" />
                    </div>
                    <h3 className="text-3xl md:text-4xl font-black text-[#0D3B3B] mb-4" data-id="element-1432">
                      You're on the list!
                    </h3>
                    <p className="text-[#0D3B3B]/80 font-medium text-lg max-w-md mx-auto" data-id="element-1433">
                      Thank you for joining. We'll notify you as soon as early
                      access opens.
                    </p>
                  </motion.div> : <motion.div key="form" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} data-id="element-1434">
                    <form onSubmit={handleJoin} className="space-y-8" data-id="element-1435">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-1436">
                        {/* Name */}
                        <div className="space-y-2" data-id="element-1437">
                          <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-1438">
                            Full Name
                          </label>
                          <div className="relative" data-id="element-1439">
                            <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#0D3B3B]/50" data-id="element-1440" />
                            <input type="text" required value={formData.name} onChange={e => setFormData({
                          ...formData,
                          name: e.target.value
                        })} placeholder="Adaeze Okonkwo" className="w-full bg-white/90 border-transparent rounded-xl py-4 pl-12 pr-4 text-base font-medium focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] focus:bg-white transition-all text-[#0D3B3B] placeholder:text-[#0D3B3B]/40" data-id="element-1441" />
                          </div>
                        </div>

                        {/* Email */}
                        <div className="space-y-2" data-id="element-1442">
                          <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-1443">
                            Email Address
                          </label>
                          <div className="relative" data-id="element-1444">
                            <MailIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#0D3B3B]/50" data-id="element-1445" />
                            <input type="email" required value={formData.email} onChange={e => setFormData({
                          ...formData,
                          email: e.target.value
                        })} placeholder="adaeze@example.com" className="w-full bg-white/90 border-transparent rounded-xl py-4 pl-12 pr-4 text-base font-medium focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] focus:bg-white transition-all text-[#0D3B3B] placeholder:text-[#0D3B3B]/40" data-id="element-1446" />
                          </div>
                        </div>

                        {/* Phone */}
                        <div className="space-y-2" data-id="element-1447">
                          <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-1448">
                            Phone Number
                          </label>
                          <div className="relative" data-id="element-1449">
                            <PhoneIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#0D3B3B]/50" data-id="element-1450" />
                            <input type="tel" required value={formData.phone} onChange={e => setFormData({
                          ...formData,
                          phone: e.target.value
                        })} placeholder="+234 800 000 0000" className="w-full bg-white/90 border-transparent rounded-xl py-4 pl-12 pr-4 text-base font-medium focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] focus:bg-white transition-all text-[#0D3B3B] placeholder:text-[#0D3B3B]/40" data-id="element-1451" />
                          </div>
                        </div>

                        {/* Location */}
                        <div className="space-y-2" data-id="element-1452">
                          <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-1453">
                            Location / City
                          </label>
                          <div className="relative" data-id="element-1454">
                            <MapPinIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#0D3B3B]/50" data-id="element-1455" />
                            <input type="text" required value={formData.location} onChange={e => setFormData({
                          ...formData,
                          location: e.target.value
                        })} placeholder="Lagos, Nigeria" className="w-full bg-white/90 border-transparent rounded-xl py-4 pl-12 pr-4 text-base font-medium focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] focus:bg-white transition-all text-[#0D3B3B] placeholder:text-[#0D3B3B]/40" data-id="element-1456" />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 pt-4 border-t border-[#0D3B3B]/10" data-id="element-1457">
                        {/* Uses Other App */}
                        <div className="space-y-2" data-id="element-1458">
                          <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-1459">
                            Do you currently use any similar application?
                          </label>
                          <div className="relative" data-id="element-1460">
                            <HelpCircleIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#0D3B3B]/50" data-id="element-1461" />
                            <select required value={formData.usesOtherApp} onChange={e => setFormData({
                          ...formData,
                          usesOtherApp: e.target.value
                        })} className="w-full bg-white/90 border-transparent rounded-xl py-4 pl-12 pr-4 text-base font-medium focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] focus:bg-white transition-all text-[#0D3B3B] appearance-none" data-id="element-1462">
                              <option value="" disabled data-id="element-1463">
                                Select an option
                              </option>
                              <option value="yes" data-id="element-1464">Yes</option>
                              <option value="no" data-id="element-1465">No</option>
                              <option value="not_sure" data-id="element-1466">Not sure</option>
                            </select>
                          </div>
                        </div>

                        {/* Area of Interest */}
                        <div className="space-y-3" data-id="element-1467">
                          <label className="text-sm font-bold text-[#0D3B3B] ml-1 block" data-id="element-1468">
                            Area of Interest (Select all that apply)
                          </label>
                          <div className="flex flex-wrap gap-2" data-id="element-1469">
                            {interestOptions.map(interest => {
                          const isSelected = formData.interests.includes(interest);
                          return <button key={interest} type="button" onClick={() => handleInterestToggle(interest)} className={`flex items-center gap-1.5 px-4 py-2.5 rounded-xl border text-sm font-bold transition-all ${isSelected ? 'bg-[#0D3B3B] border-[#0D3B3B] text-white' : 'bg-white/90 border-transparent text-[#0D3B3B] hover:bg-white'}`} data-id="element-1470">
                                  {isSelected && <CheckIcon className="w-4 h-4" data-id="element-1471" />}
                                  {interest}
                                </button>;
                        })}
                          </div>
                        </div>
                      </div>

                      <div className="pt-8" data-id="element-1472">
                        <button type="submit" className="w-full md:w-auto md:min-w-[300px] mx-auto bg-[#0D3B3B] hover:bg-[#092D2D] text-white py-5 px-8 rounded-2xl text-lg font-bold transition-transform active:scale-[0.98] shadow-xl shadow-[#0D3B3B]/20 flex items-center justify-center gap-2" data-id="element-1473">
                          Join the Waitlist{' '}
                          <ArrowRightIcon className="w-6 h-6" data-id="element-1474" />
                        </button>
                      </div>
                    </form>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0D3B3B] text-white/60 pb-12 pt-4 relative z-10" data-id="element-1475">
        <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-1476">
          <img src="https://cdn.magicpatterns.com/uploads/whJLzkvjNQX43Ru1gcfGZr/Group_581.png" alt="Skydd" className="h-6 w-auto opacity-60 hover:opacity-100 transition-opacity" data-id="element-1477" />
          <p className="text-sm font-medium" data-id="element-1478">
            &copy; {new Date().getFullYear()} Skydd Technologies Ltd. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-sm font-bold" data-id="element-1479">
            <a href="#" className="hover:text-[#FFD700] transition-colors" data-id="element-1480">
              Twitter
            </a>
            <a href="#" className="hover:text-[#FFD700] transition-colors" data-id="element-1481">
              LinkedIn
            </a>
            <a href="#" className="hover:text-[#FFD700] transition-colors" data-id="element-1482">
              Instagram
            </a>
          </div>
        </div>
      </footer>

      {/* Back to Top FAB */}
      <button onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} className="fixed bottom-8 right-8 w-14 h-14 bg-[#FFD700] text-[#0D3B3B] rounded-full shadow-2xl flex items-center justify-center hover:bg-[#F0C900] hover:-translate-y-1 transition-all z-50 border-2 border-white" data-id="element-1483">
        <ArrowUpIcon className="w-6 h-6" data-id="element-1484" />
      </button>
    </div>;
}